import { CSSProperties } from 'react';
import styled from 'styled-components';

import { WithThemeProps } from '../../../styles';


type RootProps = {} & WithThemeProps

const Root = styled.nav`
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	max-width: 80px;
	padding: 20px 0;

	${(p: RootProps) => p.theme && `
		background-color: ${p.theme.color.bgDark};
	`}
`;

const styles: Record<string, CSSProperties> = {
	scrollableView: {
		zIndex: 20,
		maxHeight: '100%'
	}
}

export {
	Root,
	styles
};
